"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _EotcBuySellComponent = _interopRequireDefault(require("./EotcBuySellComponent"));
var _orderEntryFormConstants = require("../../../../constants/sendOrder/orderEntryFormConstants");
var _modalActions = require("../../../../redux/actions/modalActions");
var _BuySellLayoutTypes = require("../BuySell/BuySellLayoutTypes");
var _config = _interopRequireDefault(require("../../../../config"));
var _buySellSelectors = require("../../../../redux/selectors/buySellSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellComponentForm = (0, _reduxForm.reduxForm)({
  form: 'buySell',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.EOTC_SUBMIT_ORDER));
  },
  destroyOnUnmount: false
})(_EotcBuySellComponent["default"]);
var mapStateToProps = function mapStateToProps(state) {
  var selectedValue = (0, _buySellSelectors.getOrderFormInfoSelector)(state);
  var totalQuantity = selectedValue.quantity ? selectedValue.quantity : 0;
  var displayExtraInfoComponent = totalQuantity > 0;
  return {
    initialValues: {
      side: _orderEntryFormConstants.buyValue,
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: _config["default"].RetailBuySell.orderType || _orderEntryFormConstants.orderTypes.limit.displayName,
      responseMessage: '',
      layoutType: _BuySellLayoutTypes.BUY_SELL_LAYOUTS.PRICE_PER_UNIT
    },
    displayExtraInfoComponent: displayExtraInfoComponent,
    invertArrows: true
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(BuySellComponentForm);